
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-valuation/[registration]/[mileage]",
      function () {
        return require("private-next-pages/car-valuation/[registration]/[mileage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-valuation/[registration]/[mileage]"])
      });
    }
  